import { render } from "./NotificationSurveyNotificationItemEditPane.vue?vue&type=template&id=11ce589c&scoped=true&ts=true"
import script from "./NotificationSurveyNotificationItemEditPane.vue?vue&type=script&lang=ts"
export * from "./NotificationSurveyNotificationItemEditPane.vue?vue&type=script&lang=ts"

import "./NotificationSurveyNotificationItemEditPane.vue?vue&type=style&index=0&id=11ce589c&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ce589c"]])

export default __exports__